







import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class Tabs extends Vue {
  @Prop({ default: 0 })
  private index?: number;
  @Prop({ default: 0 })
  private activeIndex?: number;

  // private get activeIndex() {
  //   return this.$parent.$data.activeIndex ? this.$parent.$data.activeIndex : 0;
  // }

  private mounted() {}
}
